<form #formRef="ngForm" [class.sidebar-active]="activeTab === 'general'">
	<bb-page-header [backOnMobile]="['/adservices/auctions']" [icon]="'gavel'"
		[title]="entity && entity.name ? entity.name : ''">
		<span class="subtitle"> {{ entity?.code }} </span>
		<ul class="tabs" *ngIf="entity">
			<li>
				<a [routerLink]="['/adservices/auction', activeId]" routerLinkActive=""
					[class.active]="activeTab === 'general'">
					<!-- hack to fix routerLinkActive after create new -->
					<i class="fa fa-tags"></i> {{ 'GENERAL' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/adservices/auction', activeId, 'modules']" routerLinkActive=""
					[class.active]="activeTab === 'modules'">
					<i class="fa fa-cubes"></i> {{ 'MODULES' | translate }}
				</a>
			</li>
			<li>
				<a [routerLink]="['/adservices/auction', activeId, 'adapters']" routerLinkActive=""
					[class.active]="activeTab === 'adapters'">
					<i class="fa fa-plug"></i> {{ 'ADAPTERS' | translate }}
				</a>
			</li>
		</ul>

		<bb-status *ngIf="entity" [(ngModel)]="entity.status" name="status" [labelOn]="'ACTIVE' | translate" [valueOn]="'active'" [valueOff]="'inactive'"
			[labelOff]="'INACTIVE' | translate"></bb-status>
	</bb-page-header>

	<div class="body-column tab-container">
		<auction-details-general [form]="form" [auction]="entity"
			*ngIf="activeTab === 'general'"></auction-details-general>
		<auction-details-modules [form]="form" [auction]="entity"
			*ngIf="activeTab === 'modules'"></auction-details-modules>
		<auction-details-adapters [form]="form" [auction]="entity"
			*ngIf="activeTab === 'adapters'"></auction-details-adapters>
	</div>
	<div class="body-column sidebar">
		
		<div class="relations-container">
			<div class="relation" *ngIf="assignments?.adunits?.length">
				<h3>{{ 'ASSIGNED_TO_AD_UNITS' | translate }}</h3>
				<div class="relation-items">
					<div class="line-start"></div>
					<div *ngFor="let adunit of assignments?.adunits" class="relation">
						<div class="line-part"></div>
						<a
							[routerLink]="['/adservices/adunits/' + adunit.id]">
							<bb-button icon="caret-square-right">
								{{ adunit.title || adunit.code }}
							</bb-button>
						</a>
					</div>
				</div>
			</div>

			<div class="relation" *ngIf="assignments?.adschedules?.length">
				<h3>{{ 'ASSIGNED_TO_AD_SCHEDULES' | translate }}</h3>
				<div class="relation-items">
					<div class="line-start"></div>
					<div *ngFor="let adschedule of assignments?.adschedules" class="relation">
						<div class="line-part"></div>
						<a
							[routerLink]="['/adservices/adschedule/' + adschedule.id]">
							<bb-button icon="caret-square-right">
								{{ adschedule.title || adschedule.code }}
							</bb-button>
						</a>
					</div>
				</div>
			</div>

			<ng-container *ngIf="relations?.lineitem?.length">
				<div class="relation" [hasPermission]="'root'" class="root">
					<h3>{{ 'RELATED_LINEITEM' | translate }}</h3>
					<div *ngFor="let lineitemId of relations?.lineitem" class="relation">
						<a
							[routerLink]="['/adservices/lineitems/' + lineitemId]" [queryParams]="{noRedirect: 'true'}"><bb-button icon="caret-square-right">
							{{ ({type: 'lineitem', value: lineitemId}) | entityLabel | async }}</bb-button>
						</a>
					</div>
				</div>
			</ng-container>
		</div>
		<bb-entity-details [entity]="entity"></bb-entity-details>
	</div>
</form>

<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" (onDelete)="delete()" [form]="form"
	[entity]="entity">
</bb-actions-bar>
